<template>
  <BuiEntityListingPage
    v-bind="listNamesConfig"
    :ItemsLister="LiveStreamsLister"
    :itemsListerBind="{ buiColumns: liveStreamsColumns }"
    :createItemPage="canCreate"
    @create="createDialog?.openModal()"
  />

  <!-- Create Live Stream modal — Phase 3 create-modal template (see PlaylistsListView). -->
  <Dialog ref="createDialog" panelClass="bui-dialog-panel">
    <template #dialog.title>Create Live Stream</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <CreateLivestreamForm @cancel="closeModal" @success="closeModalAfter(1000)" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import Dialog from '@/components/Dialog/Dialog.vue';
import CreateLivestreamForm from './CreateLiveStreamForm/CreateLiveStreamForm.vue';
import LiveStreamsLister from './LiveStreamsLister/LiveStreamsLister.vue';
import listNamesConfig from "./LiveStreamsLister/config/listNames.config";
import liveStreamsColumns from "./LiveStreamsLister/config/tableColumns.config";
import useUser from '@/composables/user';

const user = useUser();
const createDialog = ref();
const canCreate = computed(() => user.hasCreateAccessToArea(listNamesConfig.areaAccessName));
</script>

<style lang="scss" scoped>
</style>
